<template>
  <div class="container-fluid mt-2">
    <div class="row p-1">
      <div class="col col-sm-10">
        <h4>Dashboard</h4>
      </div>
    </div>

    <section class="row">
      <div class="col-md-4 mt-1">
        <div class="card text-white bg-danger mb-3 shadow h-100 py-2">
          <div class="card-header">
            <i class="fa fa-calendar-check pr-1" />Training Reschedule
          </div>
          <h1 class="text-center">
            {{ countTrainingRescheduled }}
          </h1>
        </div>
      </div>

      <div class="col-md-4 mt-1">
        <a href="#tableSched">
          <div class="card text-white bg-primary mb-3 shadow h-100 py-2">
            <div class="card-header"><i class="fa fa-calendar-check pr-1" />Training Scheduled</div>
            <h1 class="text-center">{{ countTrainingScheduled }}</h1>
          </div>
        </a>
      </div>

      <div class="col-md-4 mt-1">
        <div class="card text-white bg-secondary mb-3 shadow h-100 py-2">
          <div class="card-header">
            <i class="fa fa-calendar-check pr-1" />Training Completed
          </div>
          <h1 class="card-title text-center">
            {{ countTrainingCompleted }}
          </h1>
          <!--<div class="card-body text-center">
                    </div>-->
        </div>
      </div>

      <!-- -->
      <!--            <div class="col-md-4 mt-1">-->
      <!--                <div class="card border-left-secondary shadow h-100 py-2">-->
      <!--                    <div class="card-body">-->
      <!--                        <div class="row no-gutters align-items-center">-->
      <!--                            <div class="col mr-2">-->
      <!--                                <div class="text-xs font-weight-bold text-secondary text-uppercase mb-1 text-center">Training Completed</div>-->
      <!--                                <div class="h4 mb-0 font-weight-bold text-gray-800t text-center ">{{countTrainingCompleted}}</div>-->
      <!--                            </div>-->
      <!--                        </div>-->
      <!--                    </div>-->
      <!--                </div>-->
      <!--            </div>-->
      <!--            -->
    </section>

    <section class="row mt-3">
      <div class="col-md-12">
        <ul
          class="nav nav-justified nav-tabs d-none d-sm-flex"
          id="myTab"
          role="tablist"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              id="home-tab"
              data-toggle="tab"
              href="#home"
              role="tab"
              aria-controls="home"
              aria-selected="true"
            ><h4>Training Scheduled</h4></a>
          </li>

          <!--                    <li class="nav-item">-->
          <!--                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false"><h4>Training Complete</h4></a>-->
          <!--                    </li>-->
        </ul>

        <div
          class="tab-content"
          id="myTabContent"
        >
          <div
            class="tab-pane fade show active mt-4"
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <div v-if="crewScheduledTrainings">
              <div class="table-responsive">
                <table
                  class="table table-bordered"
                  id="tableSched"
                >
                  <thead class="table-header">
                    <tr>
                      <th
                        class="p-1"
                        width="20"
                        scope="col"
                      >
                        #
                      </th>
                      <th
                        class="p-1"
                        scope="col"
                      >
                        Training Scheduled
                      </th>
                      <th
                        class="p-1 hideInMobile"
                        scope="col"
                      >
                        Rank
                      </th>
                      <th
                        class="p-1 hideInMobile"
                        scope="col"
                      >
                        Venue
                      </th>
                      <th
                        class="p-1 hideInMobile"
                        scope="col"
                      >
                        Status
                      </th>
                      <th
                        class="p-1 hideInMobile"
                        scope="col"
                        width="100"
                      >
                        Date From
                      </th>
                      <th
                        class="p-1 hideInMobile"
                        scope="col"
                        width="100"
                      >
                        Date To
                      </th>
                      <th
                        class="p-1 hideInMobile"
                        scope="col"
                        width="100"
                      >
                        Cancelled At
                      </th>
                      <th
                        class="p-1"
                        width="50"
                        scope="col"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="(crewScheduledTraining,index) in crewScheduledTrainings"
                      :key="crewScheduledTraining.id"
                      :class="{'cancelled': crewScheduledTraining.cancelledAt,'complete' : crewScheduledTraining.trainingCompleted}"
                    >
                      <th
                        class="p-1"
                        scope="row"
                      >
                        {{ index+1 }}
                      </th>
                      <td
                        class="p-1"
                        style="overflow-wrap: inherit;"
                      >
                        {{ crewScheduledTraining.trainingCourse }}
                      </td>
                      <td class="hideInMobile">
                        {{ crewScheduledTraining.rank }}
                      </td>
                      <td
                        class="hideInMobile"
                        style="overflow-wrap: inherit;"
                      >
                        {{ crewScheduledTraining.venue }}
                      </td>
                      <td class="hideInMobile">
                        {{ evaluate(crewScheduledTraining) }}
                      </td>
                      <td class="hideInMobile">
                        {{ crewScheduledTraining.dateFrom | moment('D MMM YYYY') }}
                      </td>
                      <td class="hideInMobile">
                        {{ crewScheduledTraining.dateTo | moment('D MMM YYYY') }}
                      </td>
                      <td class="hideInMobile">
                        {{ crewScheduledTraining.cancelledAt | moment('D MMM YYYY') }}
                      </td>
                      <td class="p-1">
                        <div class="text-center">
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            title="CLICK TO SEE MORE DETAILS"
                            @click="showSchedTrainings(crewScheduledTraining.id)"
                          >
                            <i class="fa fa-eye">&nbsp;View</i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!--                    <div class="tab-pane fade mt-4" id="profile" role="tabpanel" aria-labelledby="profile-tab">-->
          <!--                        <div class="table-responsive">-->
          <!--                            <table class="table table-bordered">-->
          <!--                                <thead class="table-header">-->
          <!--                                    <tr >-->
          <!--                                        <th class="p-1" width="20" scope="col">#</th>-->
          <!--                                        <th class="p-1" scope="col">Training Completed</th>-->
          <!--                                        <th class="p-1 hideInMobile" scope="col">Rank</th>-->
          <!--                                        <th class="p-1 hideInMobile" scope="col">Venue</th>-->
          <!--                                        <th class="p-1 hideInMobile" scope="col">Status</th>-->
          <!--                                        <th class="p-1 hideInMobile" scope="col" width="100">Date From</th>-->
          <!--                                        <th class="p-1 hideInMobile" scope="col" width="100">Date To</th>-->
          <!--                                        <th class="p-1" width="50" scope="col">Action</th>-->
          <!--                                    </tr>-->
          <!--                                </thead>-->

          <!--                                <tbody v-if="crewCompleteTrainings">-->
          <!--                                &lt;!&ndash;v-for="(crewTraining,index) in crewTrainings" :key="crewTraining.id"&ndash;&gt;-->
          <!--                                    <tr v-for="(crewCompleteTraining,index) in crewCompleteTrainings" :key="crewCompleteTraining.id">-->
          <!--                                        <th class="p-1" scope="row" >{{index+1}}</th>-->
          <!--                                        <td class="p-1" style="overflow-wrap: inherit;">{{crewCompleteTraining.trainingCourse}}</td>-->
          <!--                                        <td class="hideInMobile text-center">{{crewCompleteTraining.rank ? crewCompleteTraining.rank : '-&#45;&#45;' }}</td>-->
          <!--                                        <td class="hideInMobile text-center" style="overflow-wrap: inherit;">{{crewCompleteTraining.venue ? crewCompleteTraining.venue : '-&#45;&#45;' }}</td>-->
          <!--                                        <td class="hideInMobile text-center">{{crewCompleteTraining.trainingCompleted ? crewCompleteTraining.trainingCompleted : '-&#45;&#45;'}}</td>-->
          <!--                                        <td class="hideInMobile">-->
          <!--                                            <span v-if="crewCompleteTraining.dateFrom">{{crewCompleteTraining.dateFrom | moment('D MMM YYYY')}}</span>-->
          <!--                                            <span v-else>'-&#45;&#45;'</span>-->
          <!--                                        </td>-->
          <!--                                        <td class="hideInMobile">{{crewCompleteTraining.dateTo | moment('D MMM YYYY')}}</td>-->
          <!--                                        <td class="p-1 resizeTextOnMobile">-->
          <!--                                            <div class="text-center">-->
          <!--                                                <button class="btn btn-primary btn-sm">-->
          <!--                                                    <i class="fa fa-eye">view</i>-->
          <!--                                                </button>-->
          <!--                                            </div>-->
          <!--                                        </td>-->
          <!--                                    </tr>-->
          <!--                                </tbody>-->
          <!--                            </table>-->
          <!--                        </div>-->
          <!--                    </div>-->
        </div>
      </div>
    </section>

    <!--        <ViewCrewScheduledTrainings></ViewCrewScheduledTrainings>-->
    <ViewCompleteTrainings />
  </div>
</template>

<script>
    import {mapGetters,mapActions} from 'vuex';
    import {formMixins} from "../../../../mixins/formMixins";
    import ViewCompleteTrainings from "./ViewCompleteTrainings";
    import ViewCrewScheduledTrainings from "./ViewSchedTrainings";

  export default {
      name: 'Dashboard',
      mixins: [formMixins],
      components: {ViewCrewScheduledTrainings, ViewCompleteTrainings},
      methods:{
          ...mapActions(['viewCrew','getCompleteTrainings','getScheduledTrainings','viewCrewSchedTraining','viewCrewCompletedTraining']),

          showSchedTrainingCourse(crewTraining_id){
              let crewTraining = crewTraining_id;
              this.viewCrewSchedTraining({crewTraining});
          },

          showCompletedTrainingCourse(crewTraining_id){
              //this.viewCrewCompletedTraining(crewTraining_id);
          },

          evaluate(crewScheduledTrainings) {
              if (crewScheduledTrainings.cancelledAt) {
                  return 'CANCELLED';
              }

              if (crewScheduledTrainings.wasConducted && !crewScheduledTrainings.trainingCompleted) {
                  return 'INCOMPLETE'
              } else if (!crewScheduledTrainings.wasConducted) {
                  let dateFrom = new Date(crewScheduledTrainings.dateFrom);
                  let dateTo = new Date(crewScheduledTrainings.dateTo);
                  let dateNow = new Date();
                  if (dateFrom > dateNow) {
                      return 'PENDING';
                  } else if (dateFrom >= dateNow && dateNow <= dateTo) {
                      return 'ON GOING';
                  }
              } else if(!crewScheduledTrainings.isValid) {
                  return 'EXPIRED';
              } else if ( crewScheduledTrainings.trainingCompleted && crewScheduledTrainings.wasConducted) {
                  return 'COMPLETED';
              } else {
                  return 'INCOMPLETE';
              }
          },

          showSchedTrainings(id){
              //this.$router.push(`/crew/${id}`).catch(()=>{});
              this.$router.push(`/viewSchedTrainings/${id}`).catch(()=>{});
          }
      },

      computed:{
          ...mapGetters(['userLogin','countTrainingRescheduled','countTrainingScheduled','countTrainingCompleted','crewCompleteTrainings','crewScheduledTrainings']),
      },

      created() {
         let crew = this.userLogin.id;
         this.viewCrew(crew);
         this.getScheduledTrainings({crew});
         this.getCompleteTrainings({crew});
      },

      mounted() {
          $(document).ready(function () {
              $('[data-toggle="popover"]').popover();
          });
      }
  }
</script>

<style scoped>
    @media screen and (max-width: 575px) {
       .resizeTextOnMobile{
            font-size: 9px !important;
        }

        .tab-content>.tab-pane {
            display: block !important;
            opacity: 1 !important;
            font-size: 12px !important;
        }

        .hideInMobile{
            display: none !important;
        }

        .card{
            height: 110px !important;
        }
    }

    #tableSched a:hover{
        text-decoration: none !important;
    }

    #tableSched{
        text-decoration: none;
    }

    .active{
        color: #1696ff;
    }

    .cancelled{
        background: #f3a199;
        color: black;
    }
</style>